import {type ApiFetch, apiEndpoint} from "@/components/Providers/JWTProvider.tsx";

export const doGetSchoolYears = async (apiFetch: ApiFetch) => {
    const url = new URL("/v1/instructor/school-years", apiEndpoint);
    const response = await apiFetch(url.toString());
    return await response.json();
};
